import { render } from "./SeriesForm.vue?vue&type=template&id=2d5f8de4"
import script from "./SeriesForm.vue?vue&type=script&lang=js"
export * from "./SeriesForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__